import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {Link, useHistory, useLocation} from "react-router-dom";
import CancelIcon from "../../images/activity-sitcom/cancel-icon.png";
import HelpIcon from "../../images/activity-sitcom/help-icon.png";
import * as userStore from '../../modules/userStore';

/*타임라인 조각 이미지 - 기본*/
import Time01 from "../../images/time-line/hht1_ep02/hht1_ep02_timeline_01.png";
import Time02 from "../../images/time-line/hht1_ep02/hht1_ep02_timeline_02.png";
import Time03 from "../../images/time-line/hht1_ep02/hht1_ep02_timeline_03.png";
import Time04 from "../../images/time-line/hht1_ep02/hht1_ep02_timeline_04.png";
import Time05 from "../../images/time-line/hht1_ep02/hht1_ep02_timeline_05.png";
import Time06 from "../../images/time-line/hht1_ep02/hht1_ep02_timeline_06.png";
import Time07 from "../../images/time-line/hht1_ep02/hht1_ep02_timeline_07.png";
import Time08 from "../../images/time-line/hht1_ep02/hht1_ep02_timeline_08.png";
import Time09 from "../../images/time-line/hht1_ep02/hht1_ep02_timeline_09.png";
import Time10 from "../../images/time-line/hht1_ep02/hht1_ep02_timeline_10.png";
import Time11 from "../../images/time-line/hht1_ep02/hht1_ep02_timeline_11.png";
import Time12 from "../../images/time-line/hht1_ep02/hht1_ep02_timeline_12.png";
import Time13 from "../../images/time-line/hht1_ep02/hht1_ep02_timeline_13.png";
import Time14 from "../../images/time-line/hht1_ep02/hht1_ep02_timeline_14.png";

/*타임라인 조각 이미지 - 질문*/
import Time02_q from "../../images/time-line/hht1_ep02/hht1_ep02_timeline_02_blank.png";
import Time04_q from "../../images/time-line/hht1_ep02/hht1_ep02_timeline_04_blank.png";
import Time06_q from "../../images/time-line/hht1_ep02/hht1_ep02_timeline_06_blank.png";
import Time09_q from "../../images/time-line/hht1_ep02/hht1_ep02_timeline_09_blank.png";
import Time13_q from "../../images/time-line/hht1_ep02/hht1_ep02_timeline_13_blank.png";

/*타임라인 문제 하단 이미지*/
import question_01_A from "../../images/time-line/hht1_ep02/hht1_ep02_timeline_q01_a.png"
import question_01_B from "../../images/time-line/hht1_ep02/hht1_ep02_timeline_q01_b.png"
import question_02_A from "../../images/time-line/hht1_ep02/hht1_ep02_timeline_q02_a.png"
import question_02_B from "../../images/time-line/hht1_ep02/hht1_ep02_timeline_q02_b.png"
import question_03_A from "../../images/time-line/hht1_ep02/hht1_ep02_timeline_q03_05_a.png"
import question_03_B from "../../images/time-line/hht1_ep02/hht1_ep02_timeline_q03_b.png"
import question_04_A from "../../images/time-line/hht1_ep02/hht1_ep02_timeline_q04_a.png"
import question_04_B from "../../images/time-line/hht1_ep02/hht1_ep02_timeline_q04_b.png"
//import question_05_A from "../../images/time-line/hht1_ep02/hht1_ep02_timeline_q05_a.png";
import question_05_B from "../../images/time-line/hht1_ep02/hht1_ep02_timeline_q05_b.png";

import PopReply from "../../images/pop-default/restart-btn.png";
import PopHome from "../../images/pop-default/home-btn.png";
import PopNext from "../../images/pop-default/next-btn.png";

/*css*/
import "../../css/timeline.css";
import Time02_ap from "../../images/time-line/hht1_ep01/hht1_ep01_timeline_02_ap.png";
import Guide from "../../components/guide/Guide";
import ErrorModal from "../../components/modal/ErrorModal";
import CloseActivityModal from "../../components/modal/CloseActivityModal";
import Feedback from "../../components/feedback/Feedback";
import AlertModal from "../../components/modal/AlertModal";
import {HHT1_EP2_QUIZ_ITEMS, HHT1_EP2_ANSWER_SOUNDS} from "./answer2";
import Index from "./index-ep01";
import API from "../../shared/api";
import {HHT1_EP16_QUIZ_ITEMS} from "./answer16";
import pointDirectionIcon from "../../images/direction/guide_pointer_resized.png";
import {convertToR2Url} from "../../util/url";


const TimeLineHHT1EP02 = ({ type }) => {
    const [isActive, setActive] = useState("false");
    const errorModalRef = useRef();
    const alertModalRef = useRef();
    const closeActivityModalRef = useRef();
    const feedbackRef = useRef();
    let submitDisable = false;
    let history = useHistory();
    let location = useLocation();
    const highlightImages = [Time02_q, Time02_ap];

    // 퍼즐 이미지
    const timeImage02El = useRef();
    const timeImage03El = useRef();
    const timeImage04El = useRef();
    const timeImage05El = useRef();
    const timeImage06El = useRef();
    const timeImage07El = useRef();
    const timeImage08El = useRef();
    const timeImage09El = useRef();
    const timeImage10El = useRef();
    const timeImage11El = useRef();
    const timeImage12El = useRef();
    const timeImage13El = useRef();
    const timeImage14El = useRef();

    // 퍼즐 요소
    const timeElement02 = useRef();
    const timeElement03 = useRef();
    const timeElement04 = useRef();
    const timeElement05 = useRef();
    const timeElement06 = useRef();
    const timeElement07 = useRef();
    const timeElement08 = useRef();
    const timeElement09 = useRef();
    const timeElement10 = useRef();
    const timeElement11 = useRef();
    const timeElement12 = useRef();
    const timeElement13 = useRef();
    const timeElement14 = useRef();

    const isFinishRef = useRef(false);
    const [isFinish, setIsFinish] = useState(false);
    const isClickSubmit = useRef(false);

    const isQuestionAnwers = useRef([false, false, false, false, false]);

    // const params = props.match.params;
    // const query = qs.parse(props.location.retry, { ignoreQueryPrefix: true });
    //const query = qs.parse(window.location.search, { ignoreQueryPrefix: true })
    console.log('location.state.isActivityTryAgain', location.state.isActivityTryAgain);

    // 문제를 풀고 정답일 경우 보여줘야할 요소와 이미지를 각각 묶어둔다
    // 정답이 완료되고 각각 세팅한다.
    const highlightImagesEl = [[timeImage02El], [timeImage04El], [timeImage06El], [timeImage09El], [timeImage13El]];
    const highlightElements = [[timeElement03], [timeElement05], [timeElement07, timeElement08], [timeElement10, timeElement11, timeElement12], [timeElement14]];
    const nextQuestion = [[timeElement04], [timeElement06], [timeElement09], [timeElement13]];
    const highlightSrc = [[Time02], [Time04], [Time06], [Time09], [Time13]];
    const questionsImg = [[question_01_A, question_01_B], [question_02_A, question_02_B], [question_03_A, question_03_B], [question_04_A, question_04_B], [question_03_A, question_05_B]];

    const [isShowQuestion, setIsShowQuestion] = useState(false);
    const [guideFinished, setGuideFinished] = useState(false);
    const userSelector = useSelector(store => store.userStore);
    const dispatch = useDispatch();

    const episodeInfo = userSelector.info.episodes.find(item => item.episodeId === location.state.episodeId);
    const lessonInfo = episodeInfo.lessons.find(item => item.lessonId === location.state.lessonId);
    const actInfo = lessonInfo.acts.find(item => item.actId === location.state.actId);
    const mediaPath = actInfo.media_path;
    const [isSubmitClickEvent, setIsSubmitClickEvent] = useState(false);

    const [line01, setLine01] = useState(false);
    const [questionNum, setQuestionNum] = useState(0);

    const [nextStep, setNextStep] = useState(false);

    // 선택한 답을 세팅
    const [answer, setAnswer] = useState(null);

    const feedback = (isTrue) => {
        feedbackRef.current.feedback(isTrue);
    };
    const handleClose = () => {
        stopAudio();
        closeActivityModalRef.current.openModal();
    };
    const handleGuide = () => {
        setGuideFinished(false);
    };

    /**
     * 학생 Act 학습 정보 저장 API
     * https://dcon-api.eggschool.net/api-docs/#/DCON%20Act%20%ED%95%99%EC%8A%B5%20%EC%97%B0%EB%8F%99%20API/Save
     */
    async function callApiAct() {
        if (actInfo.actStatus !== 'Completed') {
            const data = await API('post', 'act', {}, {
                oCode: userSelector.info.oCode,
                productId: userSelector.info.productId,
                studentId: userSelector.info.studentId,
                courseId: userSelector.info.courseId,
                bookId: userSelector.info.bookId,
                level: actInfo.level,
                episodeId: episodeInfo.episodeId,
                episodeCode: episodeInfo.episodeCode,
                lessonId: lessonInfo.lessonId,
                actId: actInfo.actId,
                actType: actInfo.actType,
                actStatus: "Completed",
                actPoint: actInfo.actCompletPoint,
                actCurrentPage: questionNum,
                question: JSON.stringify([]),
                answer: JSON.stringify([])
            }).catch((error) => {
                console.error(error);
            });
            userSelector.info
                .episodes.find(item => item.episodeId === location.state.episodeId)
                .lessons.find(item => item.lessonId === location.state.lessonId)
                .acts.find(item => item.actId === location.state.actId)
                .actStatus = "Completed";

            dispatch(userStore.save(userSelector.info));
        }
    }

    const routeLearningHome = () => {
        let routerName = '';
        switch (userSelector.info.productName.toUpperCase()) {
            case 'HHT1':
                routerName = '/hh1/learning-home';
                break;
            case 'HHT2':
                routerName = '/hh2/learning-home';
                break;
            case 'CULTURE':
                routerName = '/culture/learning-home';
                break;
            default:
                break;
        }
        history.push(routerName);
    };
    const ToggleClass = () => {
        setActive(!isActive);
    };

    useEffect(()=>{
        return () => {
            console.log('stopAudio');
            stopAudio();
        }
    },[])

    const playIndex = useRef(0);
    const isPlaying = useRef(false);
    const isAutoPlay = useRef(true);
    const audioService = useRef(new Audio());
    const isMaxPlayCount = useRef(1);

    audioService.current.onended = () => {
        //TODO: 마지막 로직 추가
        // alert('end'+questionNum);
        // 마지막 문제 풀었을 경우 팝업창
        if (isQuestionAnwers.current[isQuestionAnwers.current.length - 1]) {
            callApiAct();
            setIsFinish(true);
            isFinishRef.current = true;
        }

        if(isClickSubmit.current && isMaxPlayCount.current === 0) {
            nextQuestions();
        }

        if(isMaxPlayCount.current > 0) {
            if(HHT1_EP2_QUIZ_ITEMS[questionNum].exception){
                highlightElements[questionNum][2].current.style.display = 'block';
            } else {
                if (highlightElements[questionNum].length > 1) {
                    highlightElements[questionNum][1].current.style.display = 'block';
                }
            }
            isMaxPlayCount.current = isMaxPlayCount.current - 1;
            

            if (HHT1_EP2_QUIZ_ITEMS[questionNum].sound.length > 1) {
                play(HHT1_EP2_QUIZ_ITEMS[questionNum].sound[1]);
            }
        }
    };

    const stopAudio = () =>{
        audioService.current.pause();
        isPlaying.current = false;
    }
    const RenderGuideActivityArea = () => {
        if (!guideFinished && location.state.isActivityTryAgain !== 'Y') {
            return (
                <Guide setGuideFinished={setGuideFinished} />
            )
        } else {
            if (isFinish) {
                return (
                    <div className="d-flex justify-content-center align-items-center">
                        <div className="modal_overlay"></div>
                        <div className="modal_wrapper great-pop">
                            <div className="modal_inner">
                                <div className="title">You did great!</div>
                                <div className="buttongroup img-btn">
                                    <span>
                                        <Link
                                            to={{
                                                pathname: "/hh1/time-line",
                                                state: {
                                                    episodeCode: episodeInfo.episodeCode,
                                                    actInfo: actInfo,
                                                    episodeId: episodeInfo.episodeId,
                                                    lessonId: lessonInfo.lessonId,
                                                    actId: actInfo.actId,
                                                    isActivityTryAgain: 'Y'
                                                }
                                            }}
                                        >
                                            <img src={PopReply} alt="" /></Link>
                                    </span>
                                    <span><img src={PopHome} onClick={() => routeLearningHome()} alt="" /></span>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            } else {
                return '';
            }
        }
    }

    /**
     * show
     */
    const showMapImage = (showImageNum) => {

    }

    /**
     * play Audio
     * @param curIndex
     */
    const play = (curIndex)=>{
        if (isPlaying.current && curIndex == playIndex.current ) {
            audioService.current.pause();
            isPlaying.current = false;
            return;
        }

        isPlaying.current = true;
        audioService.current.src = convertToR2Url(mediaPath) + HHT1_EP2_ANSWER_SOUNDS[curIndex];

        console.log('audioService.current.src',audioService.current.src)

        audioService.current.autoPlay = true;
        playIndex.current = curIndex;
        const promise = audioService.current.play();

        if (promise !== undefined) {
            promise.then(_ => {
            }).catch(error => {
                console.log('error', error)
                isPlaying.current = false;
            });
        }
    }
    useEffect(() => {
        console.log('useEffect', guideFinished)
        if (guideFinished || location.state.isActivityTryAgain) {
            play(0);
        }
    }, [guideFinished, location.state.isActivityTryAgain]);

    /**
     * 질문 내용
     * @type {showQuestion}
     */
    const showQuestion = (questionNum) => {
        //question_01_A = question_02_A;
        submitDisable = false;
        // 이전에 문제를 풀었는지 확인
        if(!isQuestionAnwers.current[questionNum]) {
            //alert(questionNum);

            isClickSubmit.current = false;
            setQuestionNum(questionNum);
            setIsShowQuestion(true);
        }
    }

    const showPointDirection = (e,questionNum) =>{
        if (e.type === "mouseover") {
            console.log(e.target.current)
            e.target.style.cursor = `url(${pointDirectionIcon}) 12 0, auto`;
        } else if (e.type === "mouseleave") {
            e.target.style.cursor = "default";
        }else if (e.type === "mouseup" || e.type === "touchend") {
            showQuestion(questionNum)
        }
    }


    /**
     * 질문 이미지 하이라이트 표현
     * 3번 실행
     */
    const showHightlight = (showImgNum)=>{
        let intervalTimes = 1;
        const showHightlight = setInterval(()=>{
            console.log('clearInterval(showHightlight);', intervalTimes);
            if(intervalTimes > 2){
                clearInterval(showHightlight);
            }
            highlightImagesEl[showImgNum].current.src = highlightImages[intervalTimes%2];
            intervalTimes++;
        }, 500);
    }
    /**
     * 모달 정답 A
     */
    const onClickAnwerA = (e) => {
        if (e.type === "mouseover") {
            console.log(e.target.current)
            e.target.style.cursor = `url(${pointDirectionIcon}) 12 0, auto`;
        } else if (e.type === "mouseleave") {
            e.target.style.cursor = "default";
        }else if (e.type === "mouseup" || e.type === "touchend") {
            play(HHT1_EP2_QUIZ_ITEMS[questionNum].SoundIndexA);
            setAnswer(HHT1_EP2_QUIZ_ITEMS[questionNum].A);
            setIsSubmitClickEvent(true);
        }


    }

    const onClickAnwerB = (e) => {
        if (e.type === "mouseover") {
            console.log(e.target.current)
            e.target.style.cursor = `url(${pointDirectionIcon}) 12 0, auto`;
        } else if (e.type === "mouseleave") {
            e.target.style.cursor = "default";
        }else if (e.type === "mouseup" || e.type === "touchend") {
            play(HHT1_EP2_QUIZ_ITEMS[questionNum].SoundIndexB);
            setAnswer(HHT1_EP2_QUIZ_ITEMS[questionNum].B);
            setIsSubmitClickEvent(true);
        }
    }

    /**
     * 정답을 맞춘 후 답변 퍼즐을 보여준다.
     */
    const answerPuzzle = () => {
        // 정답 퍼즐 표시
        highlightImagesEl[questionNum][0].current.src = highlightSrc[questionNum][0];

        // 다음 퍼즐 함수 호출
        nextPuzzle();
    }

    /**
     * 정답 퍼즐이 보여준 뒤 다음 퍼즐을 보여준다.
     */
    const nextPuzzle = () => {
        //play하면서 사운드 1개 차감 디폴트
        isMaxPlayCount.current = HHT1_EP2_QUIZ_ITEMS[questionNum].sound.length - 1;

        play(HHT1_EP2_QUIZ_ITEMS[questionNum].sound[0]);

        if(HHT1_EP2_QUIZ_ITEMS[questionNum].exception){
            highlightElements[questionNum][1].current.style.display = 'block';
        }
        highlightElements[questionNum][0].current.style.display = 'block';

    }

    /**
     * 다음 질문 퍼즐을 보여준다.
     */
    const nextQuestions = (callback) => {
        if (!isFinishRef.current) {
            nextQuestion[questionNum][0].current.style.display = 'block';
        }
    }

    /**
     * 질문 완료 팝업 닫기
     * @returns {Promise<unknown>}
     */
    const answerPopupClose = () => {
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve(setIsShowQuestion(false));
            }, 1400);
        })
    }

    /**
     * 정답 선택 후 submit 실행
     */
    const onSubmitAnswer = async () => {
        // 오디오를 종료
        if(submitDisable){
            return;
        }
        stopAudio();

        // 선택한 답이 정답일 경우
        if(HHT1_EP2_QUIZ_ITEMS[questionNum].answer === answer) {

            submitDisable = true;
            isClickSubmit.current = true;
            // true일 경우 정답 화면 표시 (오른쪽 상단 이미지)
            feedback(true);
            // 정답 음성 종료 후 질문 팝업창 닫기
            await answerPopupClose();
            // 정답 퍼즐 실행 -> 다음 질문 퍼즐 실행 (음성) -> 다음 질문 퍼즐 실행
            answerPuzzle();

            setIsSubmitClickEvent(false);

            isQuestionAnwers.current[questionNum] = true;

        } else {
            feedback(false);
            return;
        }

    }

    const onSubmitClickEventButton =
        <button  value={answer} onClick={()=>onSubmitAnswer()} className="check-btn on" >Submit</button>;

    const offSubmitClickEventButton =
        <button className="check-btn" >Submit</button>;

    {/*타임라인 hht1 ep02*/}
    const lessonToDay = {"Lesson 1" : "Day 1", "Lesson 2" : "Day 2", "Lesson 3" : "Day 3", "Lesson 4" : "Day 4", "Lesson 5" : " Day 5"};
    return (
        <div className="time-line">
            <div>
                <div className="contents d-flex flex-column justify-content-between">
                    <ErrorModal ref={errorModalRef} handleOk={routeLearningHome} />
                    <CloseActivityModal ref={closeActivityModalRef} />
                    <Feedback ref={feedbackRef} />
                    <AlertModal ref={alertModalRef} />
                    <div className="route_bar d-flex align-items-center justify-content-between route-bar-background-hh1">
                        <div className="d-flex">
                            <p>
                                {episodeInfo.episodeName} &gt;{lessonToDay[lessonInfo.lessonTitle]}  &gt;<span className="extra-bold">{" Timeline"}</span>
                            </p>
                        </div>
                        <div className="right_icon">
                            <img className="help_icon_img" src={HelpIcon} onClick={() => handleGuide()} alt="" />
                            <img className="cancel_icon_img" src={CancelIcon} alt="" onClick={() => handleClose()} />
                        </div>
                    </div>
                </div>
            </div>
            <div className="box_parent hht1-timeline-ep02">
                <div className="box-wrap d-flex justify-content-center align-items-center">
                    <RenderGuideActivityArea />
                    <div className="timeline-bg-area">
                        <div className='bg line01 top show'
                            style={{'display':'block', 'width': '18.5%','height':'26.6%','left':'30.2%','top':'-2%'}}>
                            <img src={Time01} alt="" />
                        </div>
                        <div className='bg line02 left on'
                             style={{'display':'block', 'width': '25.7%','height':'23%','left':'1%','top':'11.4%','z-index':'-1'}}
                             ref={timeElement02}
                             // onClick={()=>showQuestion(0)}
                             onMouseOver={(e)=>showPointDirection(e,0)}
                             onMouseLeave={(e)=>showPointDirection(e,0)}
                             onMouseUp={(e)=>showPointDirection(e,0)}
                        >
                            <img ref={timeImage02El} src={Time02_q} alt=""  />
                        </div>
                        <div className="bg line03"
                             style={{'width': '42.6%','height':'13.5%','left':'1.2%','top':'28.6%'}}
                             ref={timeElement03}
                        >
                            <img ref={timeImage03El} src={Time03} alt="" />
                        </div>
                        <div className="bg line04"
                             style={{'width': '33.2%','height':'26.9%','left':'11%','top':'35.1%'}}
                             ref={timeElement04}
                             // onClick={()=>showQuestion(1)}
                             onMouseOver={(e)=>showPointDirection(e,1)}
                             onMouseLeave={(e)=>showPointDirection(e,1)}
                             onMouseUp={(e)=>showPointDirection(e,1)}
                        >
                            <img ref={timeImage04El} src={Time04_q} alt="" />
                        </div>
                        <div className="bg line05 left"
                             style={{'width': '28.8%','height':'26.5%','left':'2.3%','top':'54.2%'}}
                             ref={timeElement05}
                        >
                            <img ref={timeImage05El} src={Time05} alt="" />
                        </div>
                        <div className="bg line06 bottom"
                             style={{'width': '30.8%','height':'25.5%','left':'21.5%','top':'70.4%'}}
                             ref={timeElement06}
                             // onClick={()=>showQuestion(2)}
                             onMouseOver={(e)=>showPointDirection(e,2)}
                             onMouseLeave={(e)=>showPointDirection(e,2)}
                             onMouseUp={(e)=>showPointDirection(e,2)}
                        >

                            <img ref={timeImage06El} src={Time06_q} alt="" />
                        </div>
                        <div className="bg line07 bottom"
                             style={{'width': '42%','height':'28.5%','left':'52%','top':'70.5%'}}
                             ref={timeElement07}
                        >
                            <img ref={timeImage07El} src={Time07} alt="" />
                        </div>
                        <div className="bg line08"
                             style={{'width': '37.1%','height':'23.2%','left':'57%','top':'53.5%'}}
                             ref={timeElement08}
                        >
                            <img ref={timeImage08El} src={Time08} alt="" />
                        </div>
                        <div className="bg line09"
                             style={{'width': '28.5%','height':'16.2%','left':'56.6%','top':'44.6%'}}
                             ref={timeElement09}
                             // onClick={()=>showQuestion(3)}
                             onMouseOver={(e)=>showPointDirection(e,3)}
                             onMouseLeave={(e)=>showPointDirection(e,3)}
                             onMouseUp={(e)=>showPointDirection(e,3)}

                        >
                            <img ref={timeImage09El} src={Time09_q} alt="" />
                        </div>
                        <div className="bg line10 right index"
                             style={{'width': '13.7%','height':'14.1%','left':'84.7%','top':'46.5%'}}
                             ref={timeElement10}
                        >
                            <img ref={timeImage10El} src={Time10} alt="" />
                        </div>
                        <div className="bg line11 right"
                             style={{'width': '19.8%','height':'32%','left':'78%','top':'20.2%'}}
                             ref={timeElement11}
                        >
                            <img ref={timeImage11El} src={Time11} alt="" />
                        </div>
                        <div className="bg line12"
                             style={{'width': '23.5%','height':'28.6%','left':'54.8%','top':'12.5%'}}
                             ref={timeElement12}
                        >
                            <img ref={timeImage12El} src={Time12} alt="" />
                        </div>
                        <div className="bg line13"
                             style={{'width': '23.8%','height':'14.4%','left':'57.8%','top':'4.5%'}}
                             ref={timeElement13}
                             // onClick={()=>showQuestion(4)}
                             onMouseOver={(e)=>showPointDirection(e,4)}
                             onMouseLeave={(e)=>showPointDirection(e,4)}
                             onMouseUp={(e)=>showPointDirection(e,4)}
                        >
                            <img ref={timeImage13El} src={Time13_q} alt="" />
                        </div>
                        <div className="bg line14 right"
                             style={{'width': '20.4%','height':'16.5%','left':'80.8%','top':'3.5%'}}
                             ref={timeElement14}
                        >
                            <img ref={timeImage14El} src={Time14} alt="" />
                        </div>
                    </div>
                </div>
            {/*타임라인 문제 팝업*/}
                {
                    isShowQuestion &&
                    <div className="time-pop-inner" style={{'display': 'block'}}>
                        <div className="time-line-pop" style={{'display': 'block'}}>
                            <div className="question-layer">
                                <div className="select select01"
                                     tabIndex="0"
                                     // onClick={onClickAnwerA}
                                     onMouseOver={(e)=>onClickAnwerA(e)}
                                     onMouseLeave={(e)=>onClickAnwerA(e)}
                                     onMouseUp={(e)=>onClickAnwerA(e)}
                                >
                                    <p className={HHT1_EP2_QUIZ_ITEMS[questionNum].A.length >= 100 || HHT1_EP2_QUIZ_ITEMS[questionNum].B.length >= 100 ? "over_hundred" : ""} dangerouslySetInnerHTML={ { __html: HHT1_EP2_QUIZ_ITEMS[questionNum].A } }></p>
                                    <img src={questionsImg[questionNum][0]} alt="" />
                                </div>
                                <div className="select select02"
                                     tabIndex="0"
                                     // onClick={onClickAnwerB}
                                     onMouseOver={(e)=>onClickAnwerB(e)}
                                     onMouseLeave={(e)=>onClickAnwerB(e)}
                                     onMouseUp={(e)=>onClickAnwerB(e)}
                                >
                                    <p className={HHT1_EP2_QUIZ_ITEMS[questionNum].B.length >= 100 || HHT1_EP2_QUIZ_ITEMS[questionNum].A.length >= 100 ? "over_hundred" : ""} dangerouslySetInnerHTML={ { __html: HHT1_EP2_QUIZ_ITEMS[questionNum].B } }></p>
                                    <img src={questionsImg[questionNum][1]} alt="" />
                                </div>
                            </div>
                            <div className="buttongroup">
                                <div>
                                    {isSubmitClickEvent ? onSubmitClickEventButton : offSubmitClickEventButton}
                                </div>
                            </div>
                        </div>
                        <span className="shadow"></span>
                    </div>
                }
            {/*타임라인 문제 팝업*/}
            </div>
        </div>
    );
};

export default TimeLineHHT1EP02;
